import React from 'react';
import { useState, } from 'react';
import { Modal } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import {  deleteUserById } from '../../../../../../../../../../crud/users_api/users';
import { getPuestosByLocalId } from '../../../../../../../../../../crud/management_api/puestos';
import { getAllRoles } from '../../../../../../../../../../crud/configuration_api/roles';
import 'react-calendar/dist/Calendar.css';
import './DeleteUser.scss';


export interface WorkstationOption {
  id: number;
  name: string;
}

export interface PuestoOption {
  id: number;
  name: string;
  description: string; // Nueva propiedad
}

export interface RoleOption {
  id: number;
  name: string;
  description: string; // Nueva propiedad
}


export const getPuestosOptions = async () => {
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
  const response = await getPuestosByLocalId(localId);
  if (response) {
    const data = response.data;
    if (data) {
      const puestos: PuestoOption[] = data.map((puesto: any) => {
        return {
          id: puesto.puesto_id,
          name: puesto.puesto_name,
          description: puesto.puesto_description,
        };
      });
      return puestos;
    }
  }
  return [];
};

export const getRolesOptions = async () => {
  const response = await getAllRoles();
  if (response) {
    const data = response.data;
    if (data) {
      const roles: RoleOption[] = data.map((rol: any) => {
        return {
          id: rol.rol_id,
          name: rol.rol_name,
          description: rol.rol_description || "Sin descripción",
        };
      });
      return roles;
    }
  }
  return [];
};


const DeleteUser: React.FC<any> = ({
  showDeleteModal,
  setShowDeleteModal,
  currentUser,
  currentData,
  setCurrentData, 
  originalUsers, 
  setOriginalUsers
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDeleteUser = async () => {
    setIsLoading(true);
    if (currentUser) {
      try {
        const isSuccess = await deleteUserById(Number(currentUser.user_id));
        if (isSuccess) {
          toast.success('Usuario eliminado con éxito!');
          //Se cambio original users por currentData
          const updatedOriginalUsers = currentData.filter((u: any) => u.user_id !== currentUser.user_id);
          setCurrentData(updatedOriginalUsers);
          setOriginalUsers(updatedOriginalUsers);
        } else {
          console.error('Error al eliminar al usuario');
          toast.error('Error al eliminar al usuario');
        }
      } catch (error) {
        console.error('Error al eliminar al usuario', error);
        toast.error('Error al eliminar al usuario');
      }
      setShowDeleteModal(false);
    }
    setIsLoading(false);
  };

  return (
    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Confirmar eliminación</Modal.Title>
        </div>
        <button type="button" className="modal-close-button" onClick={() => setShowDeleteModal(false)}>
          <X size={22} />
        </button>
      </Modal.Header>
      <Modal.Body>Estás seguro que quieres eliminar este usuario?</Modal.Body>
      <Modal.Footer>
        <div className="mp-modal-footer">
          <button type="button" className="mp-modal-btn-cancel" onClick={() => setShowDeleteModal(false)}>
            Cancelar
          </button>
          <button type="button" className="mp-modal-btn-submit" onClick={handleDeleteUser} disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Eliminando...
              </>
            ) : (
              'Eliminar'
            )}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUser;
